'use client';

import cx from 'classnames';
import { useTranslations } from 'next-intl';
import { Conditional, useBreakpoint } from '@cat-ecom/pcc-components';
import { PAGE_BREAKPOINTS } from '@cat-ecom/pcc-components/src/constants/commonConstants';
import { ServiceTabletMobileCard } from './service-insight-tablet-mobile-card';
import { ServiceInsightDesktopCard } from './service-insight-desktop-card';
import { NoResults } from 'components/no-results';
import { NO_SERVICE_INSIGHTS_IMG } from '../../constants';
import { ServiceInsightCardProps } from '../types';
import styles from './service-insight-card.module.scss';

export const ServiceInsightCard = ({
  serviceInsights = []
}: ServiceInsightCardProps) => {
  const isDesktop = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG) ?? false;
  const t = useTranslations();
  return (
    <Conditional
      test={serviceInsights.length > 0}
      fallback={
        <NoResults
          imageUrl={NO_SERVICE_INSIGHTS_IMG}
          label={t('NO_SERVICE_INSIGHTS')}
          noResultLabel={t('NO_SERVICE_RECOMMENDATIONS')}
        />
      }
    >
      <div
        className={cx('d-flex flex-column gap-2 gap-blg-0 pb-blg-0', {
          [styles['serviceInsightCard']]: isDesktop
        })}
      >
        {!isDesktop
          ? serviceInsights
              .slice(0, 2)
              .map((item) => (
                <ServiceTabletMobileCard key={item.id} serviceInsights={item} />
              ))
          : serviceInsights.map((item) => (
              <ServiceInsightDesktopCard key={item.id} serviceInsights={item} />
            ))}
      </div>
    </Conditional>
  );
};
